import { TW_PACK } from './model.js';
// Presentation-only scope: native roles, source text and saved content stay unchanged.
export const sentencePaletteForPack = packId => packId === TW_PACK ? 'digital-pop' : undefined;
